"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ActivatedEnvironment;
(function (ActivatedEnvironment) {
    ActivatedEnvironment["Development"] = "development";
    ActivatedEnvironment["Production"] = "production";
})(ActivatedEnvironment = exports.ActivatedEnvironment || (exports.ActivatedEnvironment = {}));
var DataPlanMatchType;
(function (DataPlanMatchType) {
    DataPlanMatchType["Unknown"] = "unknown";
    DataPlanMatchType["SessionStart"] = "session_start";
    DataPlanMatchType["SessionEnd"] = "session_end";
    DataPlanMatchType["ScreenView"] = "screen_view";
    DataPlanMatchType["CustomEvent"] = "custom_event";
    DataPlanMatchType["CrashReport"] = "crash_report";
    DataPlanMatchType["OptOut"] = "opt_out";
    DataPlanMatchType["FirstRun"] = "first_run";
    DataPlanMatchType["ApplicationStateTransition"] = "application_state_transition";
    DataPlanMatchType["NetworkPerformance"] = "network_performance";
    DataPlanMatchType["Breadcrumb"] = "breadcrumb";
    DataPlanMatchType["Profile"] = "profile";
    DataPlanMatchType["Commerce"] = "commerce";
    DataPlanMatchType["UserAttributeChange"] = "user_attribute_change";
    DataPlanMatchType["UserIdentityChange"] = "user_identity_chagne";
    DataPlanMatchType["Uninstall"] = "uninstall";
    DataPlanMatchType["Media"] = "media";
    // Data Planning Specific
    DataPlanMatchType["UserAttributes"] = "user_attributes";
    DataPlanMatchType["UserIdentities"] = "user_identities";
    DataPlanMatchType["ProductAction"] = "product_action";
    DataPlanMatchType["PromotionAction"] = "promotion_action";
    DataPlanMatchType["ProductImpression"] = "product_impression";
})(DataPlanMatchType = exports.DataPlanMatchType || (exports.DataPlanMatchType = {}));
var MessageType;
(function (MessageType) {
    MessageType["Unknown"] = "unknown";
    MessageType["SessionStart"] = "session_start";
    MessageType["SessionEnd"] = "session_end";
    MessageType["ScreenView"] = "screen_view";
    MessageType["CustomEvent"] = "custom_event";
    MessageType["CrashReport"] = "crash_report";
    MessageType["OptOut"] = "opt_out";
    MessageType["FirstRun"] = "first_run";
    MessageType["ApplicationStateTransition"] = "application_state_transition";
    MessageType["NetworkPerformance"] = "network_performance";
    MessageType["Breadcrumb"] = "breadcrumb";
    MessageType["Profile"] = "profile";
    MessageType["Commerce"] = "commerce_event";
    MessageType["UserAttributeChange"] = "user_attribute_change";
    MessageType["UserIdentityChange"] = "user_identity_chagne";
    MessageType["Uninstall"] = "uninstall";
    MessageType["Media"] = "media";
})(MessageType = exports.MessageType || (exports.MessageType = {}));
var EventType;
(function (EventType) {
    EventType["Unknown"] = "unknown";
    EventType["Navigation"] = "navigation";
    EventType["Location"] = "location";
    EventType["Search"] = "search";
    EventType["Transaction"] = "transaction";
    EventType["UserContent"] = "user_content";
    EventType["UserPreference"] = "user_preference";
    EventType["Social"] = "social";
    EventType["Other"] = "other";
    EventType["Media"] = "media";
})(EventType = exports.EventType || (exports.EventType = {}));
var DataPlanValidatorType;
(function (DataPlanValidatorType) {
    DataPlanValidatorType["Unknown"] = "unknown";
    DataPlanValidatorType["JSONSchema"] = "json_schema";
})(DataPlanValidatorType = exports.DataPlanValidatorType || (exports.DataPlanValidatorType = {}));
